import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { DataGrid } from '../../components/DataGrid.js';
import { useBusinessDay } from '../../../../shared/hooks/useBusinessDay.js';

interface HistoryRow { readonly id: string; readonly templateName: string; readonly to: string; readonly sentAt: string; readonly status: string; }

export function NotificationsHistoryPage(): ReactNode {
  const { at } = useBusinessDay();
  const { token } = useAuth();
  const { t } = useTranslation();
  const [rows, setRows] = useState<HistoryRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ items: HistoryRow[] }>('/notifications/history', { token })
      .then((r) => { if (alive) setRows(r.items); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('notif.common.loading')}</p>;
  return (
    <main aria-label="history">
      <h1>{t('notif.history.title')}</h1>
      <DataGrid<HistoryRow>
        caption="history-table"
        rows={rows}
        getRowId={(r) => r.id}
        columns={[
          { key: 'sent', header: t('notif.common.sent'), value: (r) => r.sentAt, render: (r) => at(r.sentAt) },
          { key: 'template', header: t('notif.history.template'), value: (r) => r.templateName },
          { key: 'to', header: t('notif.history.to'), value: (r) => r.to },
          { key: 'status', header: t('notif.common.status'), value: (r) => r.status },
        ]}
      />
    </main>
  );
}
